/**
 Author - Muhamed Afsal
 Git - https://bitbucket.org/mohdafsal/
 **/

import React from "react";
import SafeLink from "components/commons/SafeLink";
import PropTypes from "prop-types";
import {
  PrimaryText,
  SecondaryText
} from "components/Text";
import {Dot} from "components";
import {colors} from "nxtconstants";
import styled from "styled-components";


const propTypes = {
  content: PropTypes.array.isRequired
};

const defaultProps = {
  content: []
};

const Insights = ({content}) => {
  const data = [];
  content.map((datum) => {
    const contentTagLink = (datum.categories && datum.categories.length) ?
      (`/insights/${datum.categories[0]}`)
      : "/insights";
    const contentTagText = (datum.categories && datum.categories[0]) || "insights";

    data.push((
      <InsightsArticle
        className="insights-article"
        key={datum.id}
      >
        <div className="insights-thumbnail">
          <img
            alt="insights"
            className="insights-thumbnail__image"
            src={datum.imageUrl}
          />
        </div>
        <div className="insights-content">
          <div className="insights-title">
            <SafeLink
              className="insights-title__tag--link"
              href={contentTagLink}
            >
              <PrimaryText
                additionalStyles="text-transform: uppercase; font-weight: 700"
                className="insights-title__tag"
                color={colors.razzmatazz}
              >
                {contentTagText}
              </PrimaryText>
            </SafeLink>
            <SafeLink
              className="insights-title__link"
              href={`/articles/${datum.slug}-${datum.id}`}
            >
              <SecondaryText
                additionalStyles="line-height: 3rem;"
                className="insights-title__heading"
                color={colors.luckyPoint}
                fontSize="2.3rem"
              >
                {datum.title}
              </SecondaryText>
            </SafeLink>
          </div>
          <div className="insights-footer">
            <PrimaryText
              additionalStyles="text-transform: capitalize"
              className="insights-footer__text"
              color={colors.gray}
            >
                By {datum.metaAuthor || "Team Wealthy"}
            </PrimaryText>
            <hr className="insights-divider" />
            <div
              style={{
                display: "flex",
                alignItems: "center"
              }}
            >
              <PrimaryText
                className="insights-footer__text"
                color={colors.gray}
              >
                {datum.readTime || "0"} mins read
              </PrimaryText>
            </div>
          </div>
        </div>
      </InsightsArticle>
    ));
  });

  return (
    <div className="insights-container">
      <SecondaryText
        className="insights-heading"
        fontSize="1.8rem"
      >
        STAY INFORMED
      </SecondaryText>
      <Title>Wealthy Insights</Title>
      {data}
      <SafeLink className="load-more__btn" href="/insights">
        <SecondaryText
          className="load-more__text"
          color={colors.luckyPoint}
        >
        Load More
        </SecondaryText>
        <div className="arrow__right--medium-container">
          <span className="arrow__right--medium" />
        </div>
      </SafeLink>
    </div>
  );
};
const Title = styled.h2 `
  font-family: Avenir-Heavy;
  font-weight: initial;
  color: #263276;
  font-size: 3.2rem;
  line-height: calc(3.2rem * 1.5);
  margin: 1rem 0 2rem 0;
`;
const InsightsArticle = styled.article`
`;

Insights.propTypes = propTypes;
Insights.defaultProps = defaultProps;

export default Insights;
